import { useCallback, useState } from "react";

export const useLogarithmicFilter = (minimum, maximum, callback) => {
  const [minValue, setMinValue] = useState(minimum);
  const [maxValue, setMaxValue] = useState(maximum);
  const value = [minValue, maxValue];
  const onChange = useCallback(
    ([newMin, newMax]) => {
      setMinValue(Math.exp(newMin));
      setMaxValue(Math.exp(newMax));
      if (callback != null) {
        callback();
      }
    },
    [setMinValue, setMaxValue]
  );

  const min = Math.log(minimum);
  const max = Math.log(maximum);
  const step = (Math.log(maximum) - Math.log(minimum)) / 25;

  return {
    min,
    max,
    step,
    onChange,
    value,
  };
};
